import React, {FC, memo} from 'react';
import Image from "react-bootstrap/Image";
import logo from "../../assets/logo.svg";
import {Link} from "react-router-dom";
import './style.scss'

interface LogoProps {
    height?: number
}

const Logo: FC<LogoProps> = ({height}) => {
    return (
        <Link className="mainLogo" to={'/'}>
            <Image className="mainLogo" src={logo} alt="logo" loading="lazy" height={height ? height : undefined}/>
            <label>Я ЕМ</label>
        </Link>
    );
}

export default memo(Logo);
